var _circle, _circle2, _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyBrandLogoLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22345_344782)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 19,
    r: 19,
    fill: "#CECECE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_22345_344782",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 39,
    height: 38
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 19,
    r: 19,
    fill: "#CECECE"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_22345_344782)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_22345_344782)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.0476 22.9192C27.7776 22.6851 27.4196 22.5573 27.0492 22.5627C26.6789 22.5681 26.3253 22.7063 26.0635 22.9482L19.9173 28.6228C19.6501 28.8695 19.5 29.2041 19.5 29.553C19.5 29.9019 19.6501 30.2364 19.9173 30.4832L34.4888 43.9375C35.3455 43.4774 36.0568 42.8185 36.5522 42.0261C37.0475 41.2338 37.3097 40.3355 37.3125 39.4207V30.9568L28.0476 22.9192Z",
    fill: "#FCFCFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_22345_344782)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.875 20.1875C23.8425 20.1875 25.4375 18.5925 25.4375 16.625C25.4375 14.6575 23.8425 13.0625 21.875 13.0625C19.9075 13.0625 18.3125 14.6575 18.3125 16.625C18.3125 18.5925 19.9075 20.1875 21.875 20.1875Z",
    fill: "#FCFCFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_22345_344782)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.154 18.2211C12.8893 17.9587 12.5389 17.8125 12.1746 17.8125C11.8104 17.8125 11.4599 17.9587 11.1953 18.2211L-3.0625 33.1699V38.1282C-3.0625 39.6689 -2.47874 41.1465 -1.43965 42.236C-0.400549 43.3254 1.00877 43.9375 2.47827 43.9375H30.1821C31.1453 43.9346 32.0909 43.6675 32.9252 43.1628C33.7594 42.6581 34.4531 41.9333 34.9375 41.0604L13.154 18.2211Z",
    fill: "#FCFCFC"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 0.59375C29.6655 0.59375 37.9062 8.83451 37.9062 19C37.9062 29.1655 29.6655 37.4062 19.5 37.4062C9.33451 37.4062 1.09375 29.1655 1.09375 19C1.09375 8.83451 9.33451 0.59375 19.5 0.59375Z",
    stroke: "#CECECE",
    strokeWidth: 1.1875
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_22345_344782",
    x: 14.75,
    y: 15.4375,
    width: 27.3125,
    height: 30.875,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2.375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_22345_344782"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_22345_344782",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_22345_344782",
    x: 13.5625,
    y: 5.9375,
    width: 16.625,
    height: 16.625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2.375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_22345_344782"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_22345_344782",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_22345_344782",
    x: -7.8125,
    y: 10.6875,
    width: 47.5,
    height: 35.625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2.375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_22345_344782"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_22345_344782",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22345_344782"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 19C0.5 8.50659 9.00659 0 19.5 0C29.9934 0 38.5 8.50659 38.5 19C38.5 29.4934 29.9934 38 19.5 38C9.00659 38 0.5 29.4934 0.5 19Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBrandLogoLight);
export default __webpack_public_path__ + "static/media/emptyBrandLogoLight.d5a36f4d0408222f239e0ba8c21f9d4c.svg";
export { ForwardRef as ReactComponent };